// apiConfig.js
import axios from "axios";

const api = axios.create({
  // baseURL: 'https://localhost:44384/api',
  // baseURL: 'https://pro-slay-admin-api.ginilytics.com/api/',
  baseURL: "https://admin-api.proslay.com/api/",
  // baseURL: 'http://projects.ginilytics.org:4000/api',
  // baseURL: 'http://192.168.10.108:4000/api',
  /*   baseURL:'https://flt-api-admin-staging.foundrylawgroup.com/api/', */
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem("accessToken");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

const customerAPI = axios.create({
  baseURL: "https://flt-api-staging.foundrylawgroup.com/api/",
  // baseURL: 'http://projects.ginilytics.org:4006/api',
  headers: {
    "Content-Type": "application/json",
  },
});

customerAPI.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { api, customerAPI };
